export const setCar = async (context, car) => {
  context.commit('SET_CAR', car)
}
